/* HeightObserver is a custom element for Donna Karan */
/* (Not part of original Maker theme) */
var HeightObserver = class extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {    
    this.heightinfo = null;
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(this.handleResize.bind(this));
      this.resizeObserver.observe(this);
    } else {
      var h = Math.round(this.clientHeight);
      this.heightinfo = h;
      //window.console.log('height-observer', this.getAttribute("item"), h);
      document.documentElement.style.setProperty(`--${this.getAttribute("item")}-height`, `${h}px`);
    }
  }
  disconnectedCallback () {
    if (this.resizeObserver != null) {
      this.resizeObserver.unobserve(this);
      this.resizeObserver = null;
    }
  }
  handleResize(entries) {
    entries.forEach((entry) => {
      if (entry.target === this) {
        const height = entry.borderBoxSize ? entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.borderBoxSize.blockSize : entry.target.clientHeight;
        var h = Math.round(height);
        if (h !== this.heightinfo) {
          this.heightinfo = h;
          //window.console.log('height-observer', this.getAttribute("item"), h);
          document.documentElement.style.setProperty(`--${this.getAttribute("item")}-height`, `${h}px`);
        } else {
          //window.console.log('height-observer no change', h);
        }
      }
    });
  }
};

const heightObserverEl = customElements.get('height-observer')
heightObserverEl || customElements.define('height-observer', HeightObserver)